import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CKEditorModule } from 'ngx-ckeditor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ComparatorRoutingModule } from './comparator-routing.module';
import { ComparatorComponent } from './comparator.component';

import 'hammerjs';
import 'mousetrap';
import { RouterModule } from "@angular/router";
import { PublicModule } from 'src/app/public/public.module';
import { CompanyModule } from '../company/company.module';
import { SupplierModule } from '../supplier/supplier.module';

@NgModule({
  declarations: [ComparatorComponent],
  imports: [
    CommonModule,
    NgbModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    ComparatorRoutingModule,
    CKEditorModule,
    FormsModule,
    SupplierModule,
    RouterModule,
    CompanyModule,
    PublicModule
  ],
  exports: [ComparatorComponent]
})
export class ComparatorModule {
}
